import { generate } from '@/utils/request';
const config = {
  prefix: '/spur/v1/{organizationId}/',
  items: [
    // 供应商列表
    { key: 'getSuppliers', url: 'suppliers', method: 'GET' },
    // 创建供应商
    { key: 'addSuppliers', url: 'suppliers', method: 'POST' },
    // 修改供应商
    { key: 'putSuppliers', url: 'suppliers', method: 'PUT' },
    // 删除供应商
    { key: 'deleteSuppliers', url: 'suppliers/batch', method: 'DELETE' },
    // 供应商明细
    { key: 'getSuppliersDetail', url: 'suppliers/detail', method: 'GET' },
    // 供应商导出
    { key: 'reportSuppliers', url: 'suppliers/report', method: 'GET', rType: 2 },
    // 日志
    { key: 'getPurchaseLog', url: 'operate-logs', method: 'GET' },
  ],
};
export default {
  ...generate(config),
};
